import React from 'react'
import '../CSS/AppointmentPage.css'
import Button from "@material-tailwind/react/Button";
import imgOne from'../img/imgOne.png'
import Designer from '../img/Designer.png'
import { Link } from 'react-router-dom'
import NavOnlyIcons from './NavOnlyIcons';
import SubFooter from './SubFooter';

const AppointmentPage = () => {
    return (
        <>
        <div className="AppointmentSubDiv">
            <div className="navDiv" id='AppoinNavDiv'>
                <NavOnlyIcons /> 
            </div>
            
            <div className="appointmentOptions">
                <div className="appointmentBanner">
                    <div className="appointmentBannerLeft">
                        <h1>Book Your Session</h1>
                        <p>Fix a one-on-one, confidential session with a LivLife expert</p>
                    </div>
                    <div className="appointmentBannerRight">

                    </div>
                </div>

                <div className="bookAppointmentDown">
                    <div className="SelectExpertManual">
                        <img src={Designer} alt="Let LivLife select" />
                        <div className="typeAndDesc">
                            <h1>Let LivLife select the right Expert</h1>
                            <small>Just select your preferred time and concern category. We will select the right Expert for you.</small>
                            <Link to='/select_mode'>
                            <Button
                                color="lightBlue"
                                buttonType="outline"
                                size="regular"
                                rounded={false}
                                block={false}
                                iconOnly={false}
                                ripple="dark">
                                    BOOK
                            </Button>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="bookAppointmentDown">
                    <div className="SelectExpertAuto">
                        <img src={imgOne} alt="Let YourDOST select" />
                        <div className="typeAndDesc">
                            <h1>Select your Expert</h1>
                            <small id='SelectExpAutoSmall'>Select your Expert and we will book the appointment for you.</small>
                            <Link to='/UserDashboard'>
                            <Button
                                id='selectExpertAutoBtn'
                                color="lightBlue"
                                buttonType="outline"
                                size="regular"
                                rounded={false}
                                block={false}
                                iconOnly={false}
                                ripple="dark">
                                    BOOK
                            </Button>
                        </Link>
                        </div>
                    </div>
                </div>
            
            </div>
        </div>
        <SubFooter /> 
        </>
    )
}

export default AppointmentPage
